import Navbar from "./Navbar";
import Hero from "./Hero";
import Platform from "./Platform";
import HowItWorks from "./HowItWorks";
import Discovery from "./Discovery";
import AISection from "./AISection";
import PolicyStore from "./PolicyStore";
import CTA from "./CTA";
import Footer from "./Footer";
import ZohoSalesIQ from "./ZohoSalesIQ";

export default function ExplorePage() {
  return (
    <div className="bg-surface text-ink font-figtree">
      <ZohoSalesIQ />
      <Navbar />
      <Hero />
      <Platform />
      <HowItWorks />
      <Discovery />
      <AISection />
      <PolicyStore />
      <CTA />
      <Footer />
    </div>
  );
}
